import React from 'react'
import './sun.scss'
import sun from './img/sunLens.jpeg'

export default function Sun() {
  return (
    <img src = {sun} className="sun" alt = 'sun'/>
  )
}
